export const indexOfLastDigit = (value: string): number => {
  for (let i = value.length - 1; i >= 0; i--) {
    if (value[i] !== ' ' && !isNaN(Number(value[i].trim()))) {
      return i
    }
  }
  return -1
}

export function loadScript(
  src: string,
  position: HTMLElement | null,
  id: string,
  attributes?: Record<string, string>,
) {
  if (!position) {
    return
  }

  const script = document.createElement('script')
  script.src = src
  script.async = true
  script.id = id
  attributes &&
    Object.keys(attributes).forEach((attribute) =>
      script.setAttribute(attribute, attributes[attribute]),
    )
  position.appendChild(script)

  return script
}
